(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ReceiptSearch', ReceiptSearch);

  ReceiptSearch.$inject = ['$resource', 'API_URI'];

  function ReceiptSearch($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_search/receipts/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'getReceiptsSearched': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/receipts/search',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
    });
  }
})();
